module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_000.png
// module id = 945
// module chunks = 0